import styled from 'styled-components';

export const CardBox = styled.div`
  display: flex;
  width: 80%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  @media screen and (max-width: 992px) {
    display: none;
  }
`;

export const BreadBox = styled.div`
  display: flex;
  width: 80%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  @media screen and (max-width: 992px) {
    display: none;
  }
`;

export const Paragraph = styled.p`
  font-size: 16px;
  color: ${({ color }) => color};
  margin: auto auto;
  max-width: 756px;
  font-weight: 500;
`;

export const Title = styled.h1`
  text-align: left;
  margin: ${({ margin }) => margin};
  font-size: 21px;
  color: #1b2555;
  font-weight: 700;
  max-width: 756px;

  @media screen and (max-width: 992px) {
    font-size: 18px;
  }
`;
export const SubTitle = styled.h1`
  text-align: left;
  margin: ${({ margin }) => margin};
  font-size: 18px;
  color: #1b2555;
  font-weight: 700;
  max-width: 756px;
  text-decoration: underline;

  @media screen and (max-width: 992px) {
    font-size: 18px;
  }
`;
export const ListMember = styled.li`
  font-size: 16px;
  color: ${({ color }) => color};
  margin: auto auto;
  max-width: 671px;
  font-weight: 500;
`;
